import loadable from '@loadable/component';
export const DetailsPage=loadable(() => import('./Details'));
